<template>
    <v-container fluid>
        <v-dialog
                v-model="dialogConfirm"
                persistent
                width="300"
        >
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>
                    {{$t('pgt_seguro')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="dialogConfirm = false">No</v-btn>
                    <v-btn color="primary" @click="deleteGuest()">{{$t('Si')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogExpired"
                persistent
                width="500"
        >
            <v-card class="elevation-0">
                <v-toolbar class="mb-0" dark color="warning">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout align-center justify-center>
                        <h2>{{$t('pagina_caduca')}}</h2>
                        <v-btn
                                color="primary"
                                large
                                to="/home"
                        >
                            <v-icon left>mdi-home</v-icon>
                            {{$t('inicio')}}
                        </v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('confirmar_identidad')}}</v-card-title>
                <v-card-text>
                    Selecciona <b>Sí</b> o <b>No</b>, para confirmar la Identidad.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="dialog = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row
                align="center"
                justify="center"
        >
            <v-col
                    cols="12"
                    sm="6"
            >
                <v-card
                    width="800px"
                    class="mx-auto elevation-7"
                >
                    <v-toolbar class="mb-5" dark color="primary">
                        <v-toolbar-title>
                            {{$t('confirmar_identidad')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="mt-4">
                        <v-row>
                            <v-flex xs12 sm6>
                                <v-img
                                        class="ml-4 mr-4"
                                        :src="info.avatar"
                                        height="250px"
                                        contain
                                ></v-img>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-img
                                        class="ml-4 mr-4"
                                        :src="info.idFront"
                                        height="250px"
                                        contain
                                ></v-img>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                                <h2>{{$t('Visitante')}}: {{ info.first_name}}  {{ info.last_name}}</h2>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                                <h2>{{$t('celular')}}: {{ info.cellNumber}}</h2>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                                <h2>E-Mail: {{ info.email}}</h2>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center">
                            <v-flex class="ml-4 mr-4 mt-1 mb-1" xs12 sm6>
                                <h2>{{ $t('msg_know_guest') }}</h2>
                                <v-radio-group
                                        row
                                        v-model="confirmar"
                                        prepend-icon="mdi-account"
                                        name="confirmar"
                                        :mandatory="false"
                                        :error-messages="errores.vehicle"
                                >
                                    <v-radio  :label="$t('Si')" value=true></v-radio>
                                    <v-radio label="No" value=false></v-radio>
                                </v-radio-group>
                            </v-flex>
                        </v-row>
                        <v-row
                            align="center"
                            justify="center"
                        >
                            <v-btn
                                    color="primary"
                                    :loading="loading"
                                    @click="activateGuest()"
                            >
                                {{$t('enviar')}}
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/store'
import axios from 'axios'

export default {
  name: 'validationuser',
  data () {
    return {
      confirmar: null,
      dialog: false,
      errores: [],
      info: '',
      loading: false,
      dialogExpired: false,
      dialogConfirm: false
    }
  },
  created: function () {
    this.getInfoNewGuest()
  },
  methods: {
    activateGuest: function () {
      console.log('Confirmar Identidad = ', this.confirmar)
      if (this.confirmar == null) {
        this.dialog = true
      }
      if (this.confirmar === 'true') {
        this.loading = true
        const config = {
          method: 'patch',
          url: 'https://clubtest.intrare.app/users/non_active/validation/' + this.info.id,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken,
            'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.$router.push({ path: '/user_confirmed_successfully' })
          })
          .catch(error => {
            if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', this.errores[0])
              setTimeout(this.clear, 3000)
            } else {
              if (error.response.status === 404) {
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'error')
                this.$store.commit('snackbar_change_message', this.errores[0])
                setTimeout(this.clear, 3000)
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
              }
            }
          })
          .finally(() => (this.loading = false))
      } else {
        if (this.confirmar === 'false') {
          this.dialogConfirm = true
        }
      }
    },
    deleteGuest () {
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/users/non_active/validation/' + this.info.id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Guest Deleted ....')
        this.$router.push({ path: '/user_removed_successfully' })
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getInfoNewGuest: function () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/users/non_active/' + this.$route.params['token'],
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language
        }
      }
      axios(config)
        .then(ok => {
          this.info = ok.data
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 404) {
            this.dialogExpired = true
          }
        })
        .finally(() => (this.loading = false))
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>

</style>
